﻿import { createUserManager, loadUser } from 'redux-oidc';
import { Log, WebStorageStateStore } from 'oidc-client';
import production from './helpers';
import globals from '../globals/communityGlobals';
import { silent } from '../actions/global/auth';

const appUrl = globals.urls.webUrl;
const endSessionEndpoint = globals.identityProvider.auth0Authority
  .concat('v2/logout?client_id=')
  .concat(globals.identityProvider.auth0ClientId)
  .concat('&returnTo=')
  .concat(appUrl);

const userManagerConfig = {
  client_id: globals.identityProvider.auth0ClientId,
  scope: globals.identityProvider.auth0Scope,
  authority: globals.identityProvider.auth0Authority,
  redirect_uri: `${appUrl}/Callback`,
  post_logout_redirect_uri: appUrl,
  silent_redirect_uri: `${appUrl}/Silent`,
  response_type: 'token id_token',
  automaticSilentRenew: false,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  extraQueryParams: {
    audience: globals.identityProvider.auth0Audience,
    enable_passwordless: false,
  },
  metadata: {
    end_session_endpoint: endSessionEndpoint,
    authorization_endpoint: globals.identityProvider.auth0Authority.concat('authorize'),
    issuer: globals.identityProvider.auth0Authority,
    jwks_uri: globals.identityProvider.auth0Authority.concat('.well-known/jwks.json'),
    userinfo_endpoint: globals.identityProvider.auth0Authority.concat('userinfo'),
  },
};

const userManager = createUserManager(userManagerConfig);

if (!production) {
  /* eslint-disable no-console */
  class OidcLogger {
    prefix = 'OIDC -> ';
    debug = (value, ...rest) => {
      console.debug(this.prefix + value, ...rest);
    };
    info = (value, ...rest) => {
      console.info(this.prefix + value, ...rest);
    };
    error = (value, ...rest) => {
      console.error(this.prefix + value, ...rest);
    };
    warn = (value, ...rest) => {
      console.warn(this.prefix + value, ...rest);
    };
  }
  /* eslint-enable no-console */

  Log.logger = new OidcLogger();
  Log.level = Log.INFO;
}

function processUser(store, history) {
  // ignore that on callback compoment
  if (history.location.pathname.toLowerCase().indexOf('callback') >= 0) {
    return Promise.resolve();
  }
  return userManager.clearStaleState().then(
    () => {
      const signin = () => userManager.signinRedirect();
      const handleUser = user => {
        if (!user) {
          userManager.removeUser().then(signin, signin);
        } else {
          loadUser(store, userManager);
        }
      };
      store.dispatch(silent());
      return userManager.signinSilent().then(user => handleUser(user), () => handleUser(null));
    },
    () => {},
  );
}

export { processUser, userManager };
